<template>
  <div style="padding: 30px">
    <div class="d-flex justify-space-between align-center mb-4">
      <h2 class="text-h5">Return Policies</h2>
      <v-btn color="primary" @click="fetchFromApi" :loading="fetching" class="text-capitalize">
        <v-icon left>{{ icons.mdiDownload }}</v-icon>
        Fetch from Etsy API
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="policies" :items-per-page="10" class="elevation-1 mt-5">
      <template v-slot:top>
        <v-row style="padding: 10px">
          <v-col md="2" cols="6">
            <strong>Total: </strong> {{ policies.length }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="!is_loading">
          <tr v-if="!items.length">
            <td colspan="6" class="text-center" style="padding: 20px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 25px">No Data Found!!</p>
            </td>
          </tr>
          <tr v-for="item in items" :key="item.return_policy_id">
            <td>{{ item.return_policy_id }}</td>
            <td>
              <v-chip small class="ma-2" color="primary" v-if="item.is_default" text-color="white">
                <v-icon small left>{{ icons.mdiStar }}</v-icon>
                Default
              </v-chip>
            </td>
            <td>
              <v-chip small :color="item.accepts_returns ? 'success' : 'error'" text-color="white">
                <v-icon small left>{{ item.accepts_returns ? icons.mdiCheck : icons.mdiClose }}</v-icon>
                {{ item.accepts_returns ? 'Yes' : 'No' }}
              </v-chip>
            </td>
            <td>
              <v-chip small :color="item.accepts_exchanges ? 'success' : 'error'" text-color="white">
                <v-icon small left>{{ item.accepts_exchanges ? icons.mdiCheck : icons.mdiClose }}</v-icon>
                {{ item.accepts_exchanges ? 'Yes' : 'No' }}
              </v-chip>
            </td>
            <td>
              <v-icon left color="info">{{ icons.mdiCalendarClock }}</v-icon>
              {{ item.return_deadline }} days
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center" style="padding: 80px 0px">
              <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import store from '@/store'
import { mdiDownload, mdiStar, mdiCheck, mdiClose, mdiCalendarClock } from '@mdi/js'

export default {
  data() {
    return {
      shop: null,
      is_loading: false,
      fetching: false,
      policies: [],
      headers: [
        { text: 'Policy ID', value: 'return_policy_id' },
        { text: 'Default', value: 'is_default' },
        { text: 'Accepts Returns', value: 'accepts_returns' },
        { text: 'Accepts Exchanges', value: 'accepts_exchanges' },
        { text: 'Return Deadline', value: 'return_deadline' },
      ],
      icons: {
        mdiDownload: mdiDownload,
        mdiStar: mdiStar,
        mdiCheck: mdiCheck,
        mdiClose: mdiClose,
        mdiCalendarClock: mdiCalendarClock,
      },
    }
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetchPolicies()
  },
  methods: {
    async fetchPolicies() {
      try {
        this.is_loading = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/return-policies`)
        if (response.data.success) {
          this.policies = response.data.data || []
        }
      } catch (e) {
        console.error('Error fetching return policies:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch return policies',
        })
      } finally {
        this.is_loading = false
      }
    },
    async fetchFromApi() {
      try {
        this.fetching = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/return-policies/fetch`)
        if (response.data.success) {
          this.$swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message || 'Return policies fetched successfully',
          })
          await this.fetchPolicies()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.data.message || 'Failed to fetch return policies',
          })
        }
      } catch (e) {
        console.error('Error fetching from API:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch return policies from Etsy API',
        })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>


